import {Vue, Component} from 'vue-property-decorator';
import {mapState} from 'vuex';
import {Country, Note} from './store/types';
import getNotesByCountries from './service/getNotesByCountries';

@Component({
    name: 'CountryConditions',
    computed: {
        ...mapState('mapForCountryConditions', [
            'countries',
        ]),
        ...mapState('countryConditions', [
            'countryConditions',
        ]),
    },
})
export default class CountryConditionsMixin extends Vue {
    private countries!: number[];

    private countryConditions!: Country[];

    get countryNotes(): Note[] {
        return getNotesByCountries({
            countries: this.countries,
            countryConditions: this.countryConditions,
        });
    }
}